import styled from 'styled-components'
import { LoadingContainer } from '@tuhi/components'

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    min-height: 400px;
`

/**
 * Loading indicator for lazy-loaded routes
 * Displayed while route chunks are being downloaded
 */
export function RouteLoading(): JSX.Element {
    return (
        <Container>
            <LoadingContainer text="Loading..." isLoading={true} />
        </Container>
    )
}
